import { TaskCategory, TaskConfiguration, TimeCategory } from '../context/GlobalContext'
import { useSettings } from './useSettings'
import { useMemo } from 'react'

export type TaskCategoriesProps = TaskConfiguration & {
    loaded: boolean
    defaultCategory?: TimeCategory
    getCategoryById: (key: string) => TaskCategory
}

export default function useTasks(): TaskCategoriesProps {
    const settings = useSettings()
    const loaded = useMemo(() => settings?.task !== undefined, [settings])
    const categories = useMemo(() => settings?.task?.categories || [], [settings])
    const defaultCategory = useMemo(() => categories.find(category => category.isDefault), [settings, settings?.task?.categories])
    const getCategoryById: TaskCategoriesProps['getCategoryById'] = (key: string): TaskCategory => categories.find(category => category.key === key)

    return {
        loaded,
        defaultCategory: defaultCategory,
        getCategoryById,
        expectedTime: settings?.task?.expectedTime,
        categories: categories,
    }
}
